import { configureStore } from '@reduxjs/toolkit'
import {
    persistStore,
    persistReducer,
    createTransform,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from '@reduxjs/toolkit'
import authReducer from './auth'
import menuReducer from './menu'

// A request-in-flight flag is never valid state to resurrect from storage: if the tab
// closes mid-request, a stale `loading: true` would otherwise persist forever and lock
// up any UI gated on it (see VerifyCode's submit button).
const authTransform = createTransform(
    inboundState => {
        const rest = { ...inboundState }
        delete rest.loading
        delete rest.error
        return rest
    },
    outboundState => ({ ...outboundState, loading: false, error: false }),
    { whitelist: ['auth'] }
)

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'menu'],
    transforms: [authTransform]
}

const rootReducer = combineReducers({
  auth: authReducer,
  menu: menuReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoreActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ]
            }
        })
})


const persistor = persistStore(store)

export { store, persistor}